import axios from 'axios';

export const ApiGetData = language => {
  if (language === 'EN') {
    return axios.get('struct.json');
  } else {
    return axios.get('structFIN.json');
  }
};
